module.exports = __webpack_public_path__ + "static/media/icing-orange.92904e26.png";